import { PropChallenge, PropChallengeChallengeTypeEnum, PropPlan } from 'services/generatedClientFromSwagger';

/**
 * Returns all audition challenges for a given plan, sorted by creation date (oldest → newest).
 */
export const getSortedAuditionChallenges = (plan?: PropPlan): PropChallenge[] =>
    (plan?.propChallenges ?? [])
        .filter((challenge) => challenge.challengeType === PropChallengeChallengeTypeEnum.Audition)
        .slice()
        .sort(
            (firstChallenge, secondChallenge) =>
                new Date(firstChallenge?.createdOn ?? '').getTime() -
                new Date(secondChallenge?.createdOn ?? '').getTime()
        );

/**
 * Returns the index of a specific audition challenge within the sorted audition list of a plan.
 * - 0 → first audition challenge in the plan
 * - >0 → subsequent audition challenges
 * - -1 → not found or not an audition challenge in this plan
 */
export const getAuditionIndexInPlan = (plan: PropPlan | undefined, challengeId: string | undefined): number =>
    getSortedAuditionChallenges(plan).findIndex((challenge) => challenge?.id === challengeId);
